import { useEffect, useState } from 'react';
import { useGetPatientProfilePicture } from '../api/generated/patient-controller/patient-controller.ts';
import { base64ToBlob } from '../utils/file.ts';

export function usePatientProfilePictureUrl(patientId: string) {
  const { data } = useGetPatientProfilePicture(patientId);
  const [profilePictureUrl, setProfilePictureUrl] = useState<string>();
  useEffect(() => {
    if (data?.content) {
      const blob = base64ToBlob(data.content, 'image/png');
      const newProfilePictureUrl = URL.createObjectURL(blob);
      setProfilePictureUrl(newProfilePictureUrl);
      return () => URL.revokeObjectURL(newProfilePictureUrl);
    }
  }, [data]);
  return profilePictureUrl;
}
